export const SK_LANG = {
    copyright_name:"Autorské práva",
    copyright:"© Copyright plan-b architekti. Všetky práva vyhradené.",
    title:"Plan-b architekti",
    desc:"Architektonické štúdio sídliaca v Prahe a Bratislave.",
    projects:"Projekty",
    publications:"Publikácie",
    contact:"Kontakt"
};
